export default {
    experienceBaseRoute: '/application',
    singleConfigBaseRoute: '/app',
    nuxtBaseUrl: '/bp',
    eventOptions: {
        moduleLoaded: 'moduleLoaded',
        moduleCompleted: 'moduleCompleted',
        moduleSkipped: 'moduleSkipped',
        documentUploaded: 'documentUploaded',
        documentDeleted: 'documentDeleted'
    }
}